import { APP_LINKS, APP_SUB_MENUS } from '@utils/variables';

const ACCOUNT_TOOLTIP_LINKS = [
	{
		id: 1,
		dataCy: 'account-settings-button',
		label: 'Account Settings',
		iconType: APP_SUB_MENUS.settings.overview.icon,
		pathname: APP_LINKS.settings.href,
		subpage: APP_SUB_MENUS.settings.overview.id
	},
	{
		id: 2,
		dataCy: 'faq-button',
		label: 'FAQ',
		iconType: APP_SUB_MENUS.support.faq.icon,
		pathname: APP_LINKS.support.href,
		subpage: APP_SUB_MENUS.support.faq.id
	},
	{
		id: 3,
		dataCy: 'about-us-button',
		label: 'About Us',
		iconType: APP_SUB_MENUS.support.aboutUs.icon,
		pathname: APP_LINKS.support.href,
		subpage: APP_SUB_MENUS.support.aboutUs.id
	}
];

export { ACCOUNT_TOOLTIP_LINKS };
